import React from 'react'
import { Link } from 'react-router-dom'
import { COMPANY_INFO } from '../data/pagesData'

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0c] text-zinc-400 py-16 px-6 md:px-12 font-sans">
      <div className="max-w-[1600px] mx-auto">
        {/* Main 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
          {/* Column 1: OM SAKSKÆR AUTO */}
          <div className="space-y-4">
            <h3 className="font-bold text-base md:text-lg lg:text-[25px] tracking-wider uppercase text-white">
              OM SAKSKÆR AUTO
            </h3>
            <p className="text-sm text-zinc-400 leading-relaxed">
              Hos os brænder vi for biler – og for at give vores kunder den bedst mulige service. Vi er et lokalt autoværksted med mange års erfaring, og vi hjælper både private og erhvervskunder med alt fra service og reparation til klargøring og rådgivning.
            </p>
            <div className="pt-2">
              <a
                href={COMPANY_INFO.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#046BB4] transition-colors inline-block"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f text-lg" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Column 2: KONTAKT OS */}
          <div className="space-y-4">
            <h3 className="font-bold text-base md:text-lg lg:text-[25px] tracking-wider uppercase text-white">
              KONTAKT OS
            </h3>
            <div className="text-sm text-zinc-400 space-y-1">
              <p className="text-zinc-300">Sakskær Auto</p>
              <p>Sakskærvej 75, 6800 Varde</p>
              <p className="text-xs text-zinc-500 pt-1">CVR-nummer: 34300755</p>
            </div>

            {/* Contact Links with Icons */}
            <div className="space-y-2 pt-2">
              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="flex items-center gap-2.5 text-sm font-semibold text-[#046BB4] hover:underline"
              >
                <i className="fa-solid fa-phone text-sm shrink-0" aria-hidden="true" />
                <span>{COMPANY_INFO.phone}</span>
              </a>
              <a
                href={`mailto:${COMPANY_INFO.email}`}
                className="flex items-center gap-2.5 text-sm font-semibold text-[#046BB4] hover:underline"
              >
                <i className="fa-solid fa-envelope text-sm shrink-0" aria-hidden="true" />
                <span>{COMPANY_INFO.email}</span>
              </a>
            </div>

            {/* Hours List */}
            <div className="text-sm text-zinc-400 space-y-1 pt-2">
              <p>Mandag – torsdag: 08.00 – 16.00</p>
              <p>Fredag: 08.00 – 13.00</p>
              <p>Lørdag – søndag: Lukket</p>
            </div>
          </div>

          {/* Column 3: HVAD LEDER DU EFTER? */}
          <div className="space-y-4">
            <h3 className="font-bold text-base md:text-lg lg:text-[25px] tracking-wider uppercase text-white">
              HVAD LEDER DU EFTER?
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/a-c-service/" className="text-zinc-400 hover:text-white transition-colors duration-200">AC service</Link>
              </li>
              <li>
                <Link to="/daek-og-faelge/" className="text-zinc-400 hover:text-white transition-colors duration-200">Dæk og fælge</Link>
              </li>
              <li>
                <Link to="/gearkasse-service/" className="text-zinc-400 hover:text-white transition-colors duration-200">Gearkasse service</Link>
              </li>
              <li>
                <Link to="/reparation/" className="text-zinc-400 hover:text-white transition-colors duration-200">Reparation</Link>
              </li>
              <li>
                <Link to="/service/" className="text-zinc-400 hover:text-white transition-colors duration-200">Service</Link>
              </li>
              <li>
                <Link to="/udskiftning-af-tandrem-og-taktkaede/" className="text-zinc-400 hover:text-white transition-colors duration-200">Udskiftning af tandrem og taktkæde</Link>
              </li>
              <li>
                <Link to="/walnut-blaster/" className="text-zinc-400 hover:text-white transition-colors duration-200">Walnut blaster</Link>
              </li>
              <li>
                <Link to="/kundebil/" className="text-zinc-400 hover:text-white transition-colors duration-200">Kundebil</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright Divider */}
        <div className="mt-16 pt-8 border-t border-zinc-800/80 text-center text-xs text-zinc-500">
          © Sakskær Auto
        </div>
      </div>
    </footer>
  )
}
